import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    MenuItem,
    Button,
} from '@mui/material';
import { ToastContainer } from 'react-toastify';

const EditExperienceDialog = ({ open, onClose, onSave, experience: initialExperience }) => {
    const [experience, setExperience] = useState({
        title: '',
        employmentType: '',
        company: '',
        startDate: '',
        endDate: '',
        location: '',
        description: '',
        skills: '',
        links: '',
    });

    // Initialize form with experience data when dialog opens
    useEffect(() => {
        if (open && initialExperience) {
            setExperience({
                ...initialExperience,
                // Convert arrays back to comma-separated strings for the form
                skills: Array.isArray(initialExperience.skills)
                    ? initialExperience.skills.join(',')
                    : initialExperience.skills || '',
                links: Array.isArray(initialExperience.links)
                    ? initialExperience.links.join(',')
                    : initialExperience.links || '',
                // Format dates for input[type="date"]
                startDate: initialExperience.startDate ?
                    new Date(initialExperience.startDate).toISOString().split('T')[0] : '',
                endDate: initialExperience.endDate ?
                    new Date(initialExperience.endDate).toISOString().split('T')[0] : '',
            });
        }
    }, [open, initialExperience]);

    const handleExperienceChange = (e) => {
        const { name, value } = e.target;
        setExperience((prev) => ({ ...prev, [name]: value }));
    };

    const handleSave = () => {
        // Pass ID from the original experience to maintain reference
        onSave({ ...experience, _id: initialExperience._id });
        // onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
            <DialogTitle>Edit Experience</DialogTitle>
            <DialogContent>
                <TextField
                    fullWidth
                    label="Role/Job Title"
                    name="title"
                    value={experience.title}
                    onChange={handleExperienceChange}
                    margin="normal"
                    required
                />
                <TextField
                    fullWidth
                    label="Employment Type"
                    name="employmentType"
                    value={experience.employmentType}
                    onChange={handleExperienceChange}
                    select
                    margin="normal"
                >
                    <MenuItem value="Full-time">Full-time</MenuItem>
                    <MenuItem value="Part-time">Part-time</MenuItem>
                    <MenuItem value="Internship">Internship</MenuItem>
                    <MenuItem value="Freelance">Freelance</MenuItem>
                </TextField>
                <TextField
                    fullWidth
                    label="Company or Organization"
                    name="company"
                    value={experience.company}
                    onChange={handleExperienceChange}
                    margin="normal"
                />
                <div className='w-full flex gap-2'>
                    <TextField
                        fullWidth
                        label="Start Date"
                        name="startDate"
                        type="date"
                        value={experience.startDate}
                        onChange={handleExperienceChange}
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                    />
                    <TextField
                        fullWidth
                        label="End Date"
                        name="endDate"
                        type="date"
                        value={experience.endDate}
                        onChange={handleExperienceChange}
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                    />
                </div>
                <TextField
                    fullWidth
                    label="Location"
                    name="location"
                    value={experience.location}
                    onChange={handleExperienceChange}
                    margin="normal"
                />
                <TextField
                    fullWidth
                    label="Description"
                    name="description"
                    value={experience.description}
                    onChange={handleExperienceChange}
                    margin="normal"
                    multiline
                    rows={4}
                />
                <TextField
                    fullWidth
                    label="Skills"
                    name="skills"
                    value={experience.skills}
                    onChange={handleExperienceChange}
                    margin="normal"
                    placeholder="Add skills separated by commas"
                />
                <TextField
                    fullWidth
                    label="Links"
                    name="links"
                    value={experience.links}
                    onChange={handleExperienceChange}
                    margin="normal"
                    placeholder="Add relevant links (e.g., project links)"
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>
                    Cancel
                </Button>
                <Button onClick={handleSave} color="primary" variant="contained">
                    Save Changes
                </Button>
            </DialogActions>

            <ToastContainer
                position='bottom-center'
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </Dialog>
    );
};

export default EditExperienceDialog;